(() => {
  const SESSION_KEY = "wt-gift-popup-shown";
  const SOURCE_CONTAINER_SELECTOR = ".efg-bar-min-side.efg-bar-unlocked-controls";
  const PICKER_ATTACH_RETRIES = 10;
  const PICKER_ATTACH_INTERVAL_MS = 300;

  document.addEventListener("DOMContentLoaded", () => {
    const popup = document.getElementById("GiftPromoPopup");
    if (!popup) return;

    const threshold = Number(popup.dataset.cartThreshold || 0);
    const showOnce = popup.dataset.showOnce === "true";

    const ctaButton = document.getElementById("GiftPromoPopupCta");
    const pickerWrap = document.getElementById("GiftPromoPopupPicker");
    const pickerHint = document.getElementById("GiftPromoPopupPickerHint");
    const fallbackHint = document.getElementById("GiftPromoPopupFallbackHint");

    const getSourceControls = () => {
      const container = document.querySelector(SOURCE_CONTAINER_SELECTOR);
      if (!container) return null;
      const select = container.querySelector("select");
      const button = container.querySelector("button");
      if (!select || !button) return null;
      return { select, button };
    };

    const activateFallbackMode = () => {
      if (pickerHint) pickerHint.hidden = true;
      if (fallbackHint) fallbackHint.hidden = false;
      if (pickerWrap) pickerWrap.innerHTML = "";

      if (ctaButton) {
        ctaButton.hidden = false;
        ctaButton.textContent = ctaButton.dataset.fallbackLabel || "";
        ctaButton.onclick = () => {
          popup.hide();
          window.scrollTo({ top: 0, behavior: "smooth" });
        };
      }
    };

    const activatePickerMode = (initialSelect) => {
      if (fallbackHint) fallbackHint.hidden = true;
      if (pickerHint) pickerHint.hidden = false;

      const select = document.createElement("select");
      select.className = "wt-gift-popup__select";
      select.innerHTML = initialSelect.innerHTML;
      select.value = initialSelect.value;

      select.addEventListener("change", () => {
        const source = getSourceControls();
        if (!source) {
          activateFallbackMode();
          return;
        }
        source.select.value = select.value;
        source.select.dispatchEvent(new Event("change", { bubbles: true }));
        source.select.dispatchEvent(new Event("input", { bubbles: true }));
      });

      if (pickerWrap) {
        pickerWrap.innerHTML = "";
        pickerWrap.appendChild(select);
      }

      if (ctaButton) {
        ctaButton.hidden = false;
        ctaButton.textContent = ctaButton.dataset.pickerLabel || "";
        ctaButton.onclick = () => {
          const source = getSourceControls();
          if (!source) {
            activateFallbackMode();
            return;
          }
          source.select.value = select.value;
          source.select.dispatchEvent(new Event("change", { bubbles: true }));
          source.button.click();
          popup.hide();
        };
      }
    };

    const setupPickerOrFallback = () => {
      let attempts = 0;

      const attempt = () => {
        const source = getSourceControls();
        if (source) {
          activatePickerMode(source.select);
          return;
        }
        attempts += 1;
        if (attempts >= PICKER_ATTACH_RETRIES) {
          activateFallbackMode();
          return;
        }
        setTimeout(attempt, PICKER_ATTACH_INTERVAL_MS);
      };

      attempt();
    };

    const alreadyShown = () =>
      showOnce && sessionStorage.getItem(SESSION_KEY) === "1";

    const markShown = () => {
      if (showOnce) sessionStorage.setItem(SESSION_KEY, "1");
    };

    const maybeShowPopup = (cartTotal) => {
      if (threshold <= 0) return;
      if (cartTotal < threshold) return;
      if (alreadyShown()) return;
      if (popup.hasAttribute("open")) return;

      popup.show(null);
      markShown();
      setupPickerOrFallback();
    };

    const checkCart = () => {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then((response) => response.json())
        .then((cart) => maybeShowPopup(cart.total_price))
        .catch(() => {});
    };

    checkCart();

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS === "object") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, checkCart);
    }
  });
})();
